/** Deep link to the tenant's channel management screen. */
export const NOTIFICATION_CHANNELS_HREF = "?page=notification-channels"
